// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__14mqq","title":"Images90_title__3lnsY","images":"Images90_images__1DpLi"};